import { ModuleWithProviders } from '@angular/core';
import { effects } from '@core/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

export const EffectModuleConfig: ModuleWithProviders<StoreModule> = EffectsModule.forRoot(effects);
